/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-add-on.assembly',
    'pip-add-on.hdpp',
    'pip-add-on.pro-referral',
    'pip-add-on.attach-labor',
    'pip-add-on.dual-path',
    'jquery'
], function(
    pip,
    pipAddOnAssembly,
    pipAddOnProtectionPlan,
    pipAddOnProReferral,
    pipAddOnAttachLabor,
    pipAddOnDualPath,
    $
) {
    var model = {
        addOns: {},
        addOnsPriority: [
            'installationSku',
            'assembly',
            'dualPath',
            'proReferral'
        ],
        getAddOnModuleName: function getAddOnModuleName() {
            var displayableAddOnModules = model.addOnsPriority.filter(function(addOnModuleName) {
                return (model.addOns[addOnModuleName]
                    && model.addOns[addOnModuleName].isDisplayable
                    && addOnModuleName);
            });
            return displayableAddOnModules[0];
        },
        initAddOns: function initAddOns() {
            this.addOns = {
                installationSku: {
                    isDisplayable: !!pip.installationSku,
                    init: pipAddOnAttachLabor.init
                },
                assembly: {
                    isDisplayable: pipAddOnAssembly.isAtHomeAssemblyAddOnDisplayable(),
                    init: pipAddOnAssembly.init
                },
                dualPath: {
                    isDisplayable: pipAddOnDualPath.isDualPathDisplayable(),
                    init: pipAddOnDualPath.init,
                    hdppDisabled: true
                },
                proReferral: {
                    isDisplayable: pipAddOnProReferral.isProReferralAddOnDisplayable(),
                    init: pipAddOnProReferral.init
                },
                protectionPlan: pipAddOnProtectionPlan.isProtectionPlanAddOnDisplayable()
            }
        }
    };

    var viewModel = {
        determineAddOnModuleOptions: function determineAddOnModuleOptions(modules) {
            if (modules
            && modules.addOnModule
            && modules.addOnModule.isDisplayable
            && modules.protectionPlan) {

                this.moduleOptions = {
                    addOnModule: {
                        side: 'left',
                        multipleAddOns: true
                    },
                    protectionPlan: {
                        side: 'right',
                        multipleAddOns: true
                    }
                }
            }
        },
        init: function init(modules) {
            viewModel.determineAddOnModuleOptions(modules);
            if (modules.protectionPlan && modules.addOnModule && !modules.addOnModule.hdppDisabled) {
                pipAddOnProtectionPlan.init(this.moduleOptions && this.moduleOptions.protectionPlan);
                view.updateDom.showAddOns();
            }
            if (modules.addOnModule && modules.addOnModule.isDisplayable) {
                modules.addOnModule.init(this.moduleOptions && this.moduleOptions.addOnModule);
                view.updateDom.showAddOns();
            }
            if (modules.protectionPlan && !modules.addOnModule) {
                pipAddOnProtectionPlan.init();
                view.updateDom.showAddOns();
            }

        }
    };

    var view = {
        selectors: {
            addOnContainer: '#add-on__container'
        },
        updateDom: {
            showAddOns: function showAddOns() {
                $(view.selectors.addOnContainer).toggleClass('u--hide', false);
            }
        }
    };

    return {
        init: function init() {
                model.initAddOns();
                model.addOnModuleName = model.getAddOnModuleName();

                viewModel.init({
                    addOnModule: model.addOns[model.addOnModuleName],
                    protectionPlan: model.addOns.protectionPlan
                });
        },
        model: model,
        viewModel: viewModel,
        view: view
    }
});

}.call(window));